import Vue from 'vue';
import Lang from 'vuejs-localization';

export default {
  init(language: string) {
    Lang.requireAll(require.context('@/plugins/localisation/languages', true, /\.js$/));

    Vue.use(Lang, {
      default: language
    });
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/plugins/localisation/index.ts